import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Gauge } from "@ant-design/plots";
import { BsArrowUp } from "react-icons/bs";

const DemoGauge = () => {
  const config = {
    percent: 0.2,
    radius: 0.65,
    range: {
      width: 10,
      color: ["#D9D9D9", "#EE3D29"],
    },
    gaugeStyle: {
      lineCap: "round",
    },
    width: 250,
    height: 250,
    startAngle: Math.PI,
    endAngle: 2 * Math.PI,
    indicator: null,
    statistic: {
      title: {
        offsetY: -25,
        style: {
          fontSize: "32px",
          color: "#000000",
        },
        formatter: () => "34 kg",
      },
      content: {
        offsetY: -25,
        style: {
          fontSize: "0.75rem",
          lineHeight: "44px",
          color: "#131523",
        },
        customHtml: () => {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <BsArrowUp color={"#DD243B"} />
              <span style={{ width: "fit-content" }}>CO2 Saved</span>
            </div>
          );
        },
      },
    },
  };
  return <Gauge {...config} />;
};

export default DemoGauge;
